import { client } from "./client";
import moment from "moment";
import qs from "qs";
import { errorHandler } from "./errorHandler";
import axios from "axios";

const ACCESS_TOKEN_KEY = "access_token";

// this function is used for office employee login
export async function officeEmployeeLogin(params) {
  return client()
    .post("/api/v1/sessions", params)
    .then(response => {
      if (
        response.data &&
        response.data.data &&
        response.data.data.attributes
      ) {
        let accessToken = response.data.data.attributes["access_token"];

        setAccessToken(accessToken);
      }
      return response.data;
    })
    .catch(err => errorHandler(err));
}

export function getEmployeeProfile(email, empId, currentOrganization) {
  let url = `/api/v1/profiles/${email}?employee_id=${empId}`;

  if (currentOrganization?.attributes?.soft_deleted)
    url = `${url}&login_discarded_employee=true`;

  return client()
    .get(url)
    .then(response => {
      setAccessToken(response.data.data.attributes["access_token"]);

      return response.data;
    })
    .catch(err => errorHandler(err));
}

export function updateEmployeeProfile(params, empId) {
  return client()
    .put(`/api/v1/company/profiles/${empId}?employee_id=${empId}`, params)
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

export function updateUserProfile(params, empId) {
  return client()
    .put(`/api/v1/profiles/${empId}?employee_id=${empId}`, params)
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

export function deleteEmployeefromUser(employeeToDelete, empId) {
  return client()
    .delete(`/api/v1/profiles/${employeeToDelete}?employee_id=${empId}`)
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

// this function is used to get the access token from rails api
export function getApiOfficeAccessToken() {
  return client()
    .get("/api/v1/auth/get_access_token_office")
    .then(function(response) {
      var accessToken = response.data.data["access_token"];
      setAccessToken(accessToken);
    })
    .catch(err => errorHandler(err));
}

export function getPastOrders(page, status, empId, currentOrganization) {
  if (!page) page = 1;
  if (!status) status = "";

  let url = `/api/v1/company/orders?employee_id=${empId}&status=${status}&page=${page}&per_page=${20}`;

  if (currentOrganization?.attributes?.soft_deleted)
    url = `${url}&login_discarded_employee=true`;

  return client()
    .get(url)
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

export function getOfficeEmployeeDetail() {
  return client()
    .get("/api/v1/auth/get_office_employee_details")
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

export function getEmployeeCards(empId) {
  return client()
    .get(`/api/v1/company/credit_cards?employee_id=${empId}`)
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

export function deleteEmployeeCard(id, empId) {
  return client()
    .delete(`/api/v1/company/credit_cards/${id}?employee_id=${empId}`)
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

export function addCardToProfile(token, empId) {
  return client()
    .post(`/api/v1/company/credit_cards?employee_id=${empId}`, token)
    .then(response => response)
    .catch(err => errorHandler(err));
}

export function forgotPassword(userEmail) {
  return client()
    .get(
      `/api/v1/passwords/new?email=${encodeURIComponent(
        userEmail
      )}&organization=Location`
    )
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

export function resetUserPassword(passwordObj) {
  return client()
    .post(`/api/v1/passwords`, JSON.stringify(passwordObj))
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

export function clearCart(empId) {
  return client()
    .post(`api/v1/company/carts/${empId}?employee_id=${empId}`)
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

export function orderCheckout(options, empId) {
  let params = {
    ...options
  };

  return client()
    .post(`/api/v2/company/orders?employee_id=${empId}`, params)
    .catch(err => errorHandler(err));
}

export function getAvailableDays(empId) {
  return client()
    .get(`/api/v1/company/days?employee_id=${empId}`)
    .catch(err => errorHandler(err));
}

export function getRestaurantsByDate(params) {
  return client().get("/api/v1/company/menus", { params });
}

export function getRestaurantMenu(params) {
  return client()
    .get(
      `api/v1/company/menus/${params.id}?employee_id=${params.employee_id}`,
      {
        params
      }
    )
    .catch(err => errorHandler(err));
}

export function getMenuItemOptionsAddons(params) {
  return client()
    .get(`/api/v1/company/option_categories/${params.menu_item_id}`)
    .catch(err => errorHandler(err));
}

export function addItemToCart(params, empId) {
  return client()
    .post(`/api/v2/company/cart_items?employee_id=${empId}`, params)
    .catch(err => errorHandler(err));
}

export function getCartItems() {
  return client()
    .get("/api/v1/cart/get_cart_items")
    .catch(err => errorHandler(err));
}

export function getCart(empId, tip) {
  return client()
    .get(
      `/api/v1/company/cart_items?employee_id=${empId}&tip_percentage=${tip /
        100}`
    )
    .catch(err => errorHandler(err));
}

export function cancelOrder(orderId, empId) {
  return client()
    .delete(`/api/v1/company/orders/${orderId}?employee_id=${empId}`)
    .catch(err => errorHandler(err));
}

export function getEmployeeNotifications() {
  return client()
    .get("/api/v1/office/get_employee_arrival_notifications_enabled")
    .catch(err => errorHandler(err));
}

export function getETA(orderId, empId) {
  return client()
    .get(`api/v1/company/estimated_arrivals/${orderId}?employee_id=${empId}`)
    .catch(err => errorHandler(err));
}

export function getTaxName() {
  return client()
    .get("/api/v1/office/get_taxname")
    .catch(err => errorHandler(err));
}

export function getOrderDetails(orderId, empId) {
  return client()
    .get(`/api/v1/company/orders/${orderId}?employee_id=${empId}`)
    .catch(err => errorHandler(err));
}

export function getOfficeAdminOrderDetails(orderId, empId) {
  return client()
    .get(`/api/v1/office_admin/orders/${orderId}?employee_id=${empId}`)
    .catch(err => errorHandler(err));
}

export function getEmployeeReminders() {
  return client()
    .get("/api/v1/user/office_employee_reminder_get")
    .catch(err => errorHandler(err));
}

export function saveEmployeeReminders(params) {
  return client()
    .post("/api/v2/employees/set_reminder_values", JSON.stringify(params))
    .catch(err => errorHandler(err));
}

export function changePassword(params) {
  return client()
    .post("/api/v1/user/change_password", JSON.stringify(params))
    .catch(err => errorHandler(err));
}

export function logOut(self) {
  self.$store.commit("RESET_STATE");
  localStorage.clear();
  $cookies.remove(process.env.ACCESS_TOKEN_COOKIE, "/", ".hungerhub.com");

  document.title = "hungerhub - Uncatering Login";
  window.fcWidget.setTags(["loggedout"]);
  self.$router.push("/").catch(err => {
    if (
      err.name !== "NavigationDuplicated" &&
      !err.message.includes("Avoided redundant navigation to current location")
    ) {
      errorHandler(err);
    }
  });
}

export function getAccessToken() {
  return (
    localStorage.getItem(ACCESS_TOKEN_KEY) ||
    $cookies.get(process.env.ACCESS_TOKEN_COOKIE)
  );
}

export function setAccessToken(accessToken) {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

export function setPKToken(pk) {
  localStorage.setItem("pk", pk);
}

export function clearPKToken() {
  localStorage.removeItem("pk");
}

export function isLoggedIn() {
  const pkToken = localStorage.getItem("pk");
  const accessToken = getAccessToken();
  const cookieToken = $cookies.get(process.env.ACCESS_TOKEN_COOKIE);
  if (pkToken) {
    return !!pkToken;
  } else {
    if (!accessToken && cookieToken != null) {
      localStorage.clear();
      $cookies.remove(process.env.ACCESS_TOKEN_COOKIE);
      return false;
    } else {
      return !!accessToken;
    }
  }
}

/* Office Admin API */

export function getOfficeOrders(
  sd = moment().format("YYYY-MM-DD"),
  ed = moment().format("YYYY-MM-DD"),
  employeeId
) {
  return client()
    .get(
      "/api/v1/office_admin/orders.json?employee_id=" +
        employeeId +
        "&start_date=" +
        sd +
        "&end_date=" +
        ed
    )
    .catch(err => errorHandler(err));
}

export function adminGetUserSubsidy(params) {
  return client()
    .get("/api/v1/orders/admin_get_user_subsidy", { params })
    .catch(err => errorHandler(err));
}

export function adminExportPDf(params) {
  return client()
    .get(
      "/api/v1/orders/admin_export_pdf",
      { params },
      { responseType: "blob" }
    )
    .catch(err => errorHandler(err));
}

// export function adminExportXLS(params) {
//   return client().get("/api/v1/orders/admin_export_xls", { params });
// }

export function adminExportXLS(params) {
  return client()
    .get(
      `/api/v1/office_admin/orders.xlsx?employee_id=${params.employee_id}`,
      { params },
      { responseType: "blob" }
    )
    .catch(err => errorHandler(err));
}

export function getAllOfficeEmployees(
  employeeId,
  teamFilter = "All",
  page,
  search
) {
  return client()
    .get(
      `api/v1/office_admin/employees?employee_id=${employeeId}${
        teamFilter && teamFilter !== "All"
          ? `&team_id=${encodeURIComponent(teamFilter)}`
          : ""
      }${search ? `&search_cont=${search}` : ""}${
        page ? `&page=${page}&per_page=20` : ""
      }`
    )
    .catch(err => errorHandler(err));
}

export function getOfficeEmployees(payload) {
  const paramsString = qs.stringify(payload);

  return client()
    .get(`api/v1/office_admin/employees?${paramsString}`)
    .catch(err => errorHandler(err));
}
export function getOfficeTeams(employeeId) {
  return client()
    .get("/api/v1/office_admin/teams?employee_id=" + employeeId)
    .catch(err => errorHandler(err));
}

export function setEmployeeDailySubsidy(newData) {
  const chosenDay = newData.timeSlot.split("_")[2];
  const chosenTimeSlot = newData.timeSlot.includes("dinner") ? "_dinner" : "";
  const dailyTimeSlot = "&day=" + chosenDay + chosenTimeSlot;
  const employeeIdParam = "?employee_id=" + newData.id;
  const limitParam = "&limit=" + newData.amount;

  return client()
    .post(
      "api/v1/emp/set_daily_limit" +
        employeeIdParam +
        dailyTimeSlot +
        limitParam
    )
    .catch(err => errorHandler(err));

  // notes from sudeep
  // api/v1/emp/set_daily_limit
  // This is  POST request and the parameters in take are:
  // employee_id : Pass "ALL" if you want to set the same limit for all the employees in the office. Pass the employee id of a particular employee, if you just need to update limit for that employee.
  // day : Indicates which meal and which day of the week. Possible values are:
  //       "monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday",
  //      "monday_dinner", "tuesday_dinner", "wednesday_dinner", "thursday_dinner", "friday_dinner", "saturday_dinner", "sunday_dinner"
  // Example: If you want to set limit for Monday lunch, pass "monday". If you want to set limit for Monday dinner, pass "monday_dinner"
  // limit => amount as string
}

export function setWeeklyEmployeeSubsidy(newData) {
  const chosenTimeSlot = newData.timeSlot.includes("lunch")
    ? "lunch"
    : "dinner";

  const employeeIdParam = "?employee_id=" + newData.id;
  const mealType = "&meal=" + chosenTimeSlot;
  const limitParam = "&value=" + newData.amount;

  return client()
    .post(
      "api/v1/emp/set_weekly_subsidy" + employeeIdParam + mealType + limitParam
    )
    .catch(err => errorHandler(err));
}

export function addEmployee(params) {
  return client()
    .post("api/v1/employee/add_employee", params)
    .catch(err => errorHandler(err));
}

export function deleteEmployee(empId, employeeId) {
  return client()
    .delete(`/api/v1/office_admin/employees/${empId}?employee_id=${employeeId}`)
    .catch(err => errorHandler(err));
}

export function deleteBulkEmployees(params) {
  const paramsString = qs.stringify(params, { arrayFormat: "brackets" });

  return client()
    .delete(`/api/v1/office_admin/employees?${paramsString}`)
    .catch(err => errorHandler(err));
}

export function loginAsEmployee(params) {
  return client()
    .get("/api/v1/orders/admin_login_frontend", { params })
    .catch(err => errorHandler(err));
}

export function checkEmail(email, employeeId) {
  return client()
    .get(`api/v1/profiles/${email}?employee_id=${employeeId}`)
    .catch(err => errorHandler(err));
}

export function saveEmployee(params, employeeId) {
  return client()
    .post(`api/v1/office_admin/employees?employee_id=${employeeId}`, params)
    .catch(err => errorHandler(err));
}

export function saveBulkEmployees(params, payload, chunks) {
  const paramsString = qs.stringify(params, { arrayFormat: "brackets" });

  return Promise.all(
    chunks.map(chunk => {
      const payloadCopy = { ...payload };
      payloadCopy.emp_ids = chunk;

      let url = client().put(
        `api/v1/office_admin/employees?${paramsString}`,
        payloadCopy
      );
      return url;
    })
  ).then(
    axios.spread((...allData) => {
      return allData;
    })
  );
}

export function updateEmployee(params, empId, employeeId) {
  return client()
    .put(
      `api/v1/office_admin/employees/${empId}?employee_id=${employeeId}`,
      params
    )
    .catch(err => errorHandler(err));
}

export function officeAdminCancelOrder(orderId, employeeId) {
  return client()
    .delete(`/api/v1/office_admin/orders/${orderId}?employee_id=${employeeId}`)
    .catch(err => errorHandler(err));
}

export function addItemToCartOfficeAdmin(params, empId, selectedEmpId) {
  return client()
    .post(
      `/api/v2/company/cart_items?employee_id=${empId}&cart_employee_id=${selectedEmpId}`,
      params
    )
    .catch(err => errorHandler(err));
}

export function getCartOfficeAdmin(empId, selectedEmpId, tip) {
  return client()
    .get(
      `/api/v1/company/cart_items?employee_id=${empId}&cart_employee_id=${selectedEmpId}&tip_percentage=${tip /
        100}`
    )
    .catch(err => errorHandler(err));
}

export function orderCheckoutOfficeAdmin(options, empId, selectedUser) {
  let params = {
    ...options
  };

  return client()
    .post(
      `/api/v2/company/orders?employee_id=${empId}&cart_employee_id=${selectedUser}`,
      params
    )
    .catch(err => errorHandler(err));
}

export function getEmployeeCardsOfficeAdmin(empId, selectedUser) {
  return client()
    .get(
      `/api/v1/company/credit_cards?employee_id=${empId}&cart_employee_id=${selectedUser}`
    )
    .then(response => response.data)
    .catch(err => errorHandler(err));
}

export function addTeam(params, employeeId) {
  return client()
    .post(`/api/v1/office_admin/teams?employee_id=${employeeId}`, params)
    .catch(err => errorHandler(err));
}

export function deleteTeam(teamId, employeeId) {
  return client()
    .delete(`/api/v1/office_admin/teams/${teamId}?employee_id=${employeeId}`)
    .catch(err => errorHandler(err));
}

export function updateTeam(teamId, params, employeeId) {
  return client()
    .put(
      `/api/v1/office_admin/teams/${teamId}?employee_id=${employeeId}`,
      params
    )
    .catch(err => errorHandler(err));
}

export function deleteEmployeeFromTeam(empId, params, employeeId) {
  return client()
    .delete(
      `/api/v1/office_admin/employee_teams/${empId}?employee_id=${employeeId}`,
      { data: params }
    )
    .catch(err => errorHandler(err));
}

export function assignEmployeeToTeam(empId, teamId, employeeId) {
  return client()
    .put(
      `/api/v1/office_admin/employee_teams/${empId}?employee_id=${employeeId}`,
      { team_id: teamId }
    )
    .catch(err => errorHandler(err));
}

export function massAssignmentToTeam(params, teamId, employeeId) {
  return client()
    .put(
      `/api/v1/office_admin/team_assignments/${teamId}?employee_id=${employeeId}`,
      params
    )
    .catch(err => errorHandler(err));
}

export function assignEmployeeToTeams(empId, params, employeeId) {
  return client()
    .put(
      `/api/v1/office_admin/employee_teams/${empId}?employee_id=${employeeId}`,
      params
    )
    .catch(err => errorHandler(err));
}

export function getAllOfficeAdmins(employeeId) {
  return client()
    .get(`api/v1/office_admin/employees?employee_id=${employeeId}&admin=true`)
    .catch(err => errorHandler(err));
}



// WEBPACK FOOTER //
// ./src/utils/api.js